import React, { useEffect, useState } from "react";
import profileStyle from "./MyProfile.module.css";
import { FaTimes } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import { useTenantPlan } from "../../hooks/useTenantPlan";

const MyProfile = () => {
  const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [tenantPlan, setTenantPlan] = useState(null);

  const {
    plan,
    loading: planLoading,
    error: planError,
  } = useTenantPlan();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Authorization token not found in local storage.");
        return;
      }

      try {
        const response = await fetch(
          `https://auth2.${backend_api_base_url}/me`,
          {
            method: "GET",
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
        setFormData({
          full_name: result.full_name,
          phone: result.phone,
        });
      } catch (err) {
        setError(err.message);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCloseModal = () => {
    setIsEditing(false);
  };

  const handleSaveClick = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("Authorization token not found in local storage.");
      return;
    }

    try {
      const response = await fetch(`https://auth2.${backend_api_base_url}/me`, {
        method: "PUT",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.message === "User updated successfully") {
        setData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        setIsEditing(false);
      } else {
        setError("Data was not saved. Please try again.");
        setIsEditing(true);
      }
    } catch (err) {
      setError(err.message);
      setIsEditing(true);
    }
  };

  if (error) return <div className="error">Error: {error}</div>;
  if (!data) return <div className="loading">Loading...</div>;

  return (
    <div className={profileStyle.container}>
      <div className={profileStyle.profile}>
        {data.image ? (
          <img
            src={data.image}
            alt="Profile"
            className={profileStyle["profile-image"]}
          />
        ) : (
          <div className={profileStyle["profile-image-placeholder"]}>
            {/* SVG fallback omitted for brevity */}
          </div>
        )}

        <div className={profileStyle.rectangle}>
          <>
            <h1 className={profileStyle.name}>{data.full_name}</h1>
            <p className={profileStyle.phone}>Phone: {data.phone}</p>
            {/* 
            
            <button
              className={profileStyle["edit-button"]}
              onClick={handleEditClick}
            >
              <BiSolidEdit size={18} />
            </button>
            */}

            <p className={profileStyle.email}>Email: {data.email}</p>
            <p className={profileStyle.gender}>Gender: {data.gender}</p>
            <p className={profileStyle.tenant}>Tenant: {data.tenant}</p>

            <h2 className={profileStyle.tenant_info}>
              Current Subscription Plan
            </h2>
            <div className={profileStyle["tenant-info"]}>
              <p className={profileStyle["tenant-plan"]}>
                {/* Plan: {(tenantPlan && tenantPlan.plan) || "Loading..."} */}
                Plan: {planLoading ? "Loading..." : plan || "N/A"}
              </p>

              {planError && (
                <p
                  className={profileStyle["plan-error"]}
                  style={{ color: "red" }}
                >
                  Error loading plan: {planError}
                </p>
              )}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
